import UiModal from '../../../../js/components/UiModal/UiModal';
import { Slider } from '../../../../js/components/Slider/Slider';

export class WorkHistoryModal extends UiModal {
  constructor(template, options = {}) {
    super(template, {
      wrapperClass: 'work-v4-popup',
      isIndent: false,
      blockTriggerName: options.blockName
    });

    this._slider = null;
  }

  _sliderInit() {
    const slider = this.element.querySelector('.js-slider');
    const slides = this.element.querySelectorAll('.js-slider-item');
    const controls = this.element.querySelector('.js-slider-controls');
    const isInit = slides.length > 1;

    const options = {
      wrapper: slider,
      settings: {
        slideClass: 'js-slider-item',
        slideActiveClass: 'js-slider-item-active',
        wrapperClass: 'js-slider-list',

        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },

        pagination: {
          el: '.js-slider-count',
          currentClass: 'controls__current',
          type: 'fraction',
        },

        navigation: {
          nextEl: '.js-slider-next',
          prevEl: '.js-slider-prev',
          disabledClass: 'button-arrow--disabled'
        },

        on: {
          realIndexChange: () => {
            this.scrollTopContent();
          }
        }
      },
      modules: ['pagination', 'navigation', 'effectFade'],
      initCondition: {
        sm: isInit,
        md: isInit,
        lg: isInit,
        xl: isInit
      },
      controls
    };

    this._slider = new Slider(options);
    this._slider.init();
  }

  mounted() {
    super.mounted()
    this._sliderInit()
  }

  unmounted() {
    super.unmounted()

    if (this._slider !== null) {
      this._slider.destroy();
      this._slider = null;
    }
  }
}
